import { ref } from "vue";

const fadeModalBg = () => {
  const tempModal = document.getElementById("modal-bg");
  if (tempModal) tempModal.classList.add("fadeOut");
};

const removeModalBg = () => {
  const tempModal = document.getElementById("modal-bg");
  if (tempModal) tempModal.remove();
};

const createModalBg = () => {
  const tempModal = document.getElementById("modal-bg");
  if (!tempModal) {
    const tempDiv = document.createElement("div");
    tempDiv.setAttribute("id", "modal-bg");
    document.body.append(tempDiv);
  }
};

export default () => {
  const showModal = ref(false);
  const bounceTransition = ref("bounceInDown");
  const fadeTransition = ref("");
  const timeOut = ref(250);

  const handleModal = (): Promise<void> => {
    return new Promise((resolve) => {
      if (showModal.value) {
        fadeModalBg();
        fadeTransition.value = "fadeOut";

        setTimeout(() => {
          removeModalBg();

          fadeTransition.value = "";
          showModal.value = !showModal.value;

          resolve();
        }, timeOut.value);
      } else {
        createModalBg();
        showModal.value = !showModal.value;

        resolve();
      }
    });
  };

  const handleTransition = (): Promise<void> => {
    bounceTransition.value = "transitionUp";

    return new Promise((resolve) => {
      setTimeout(() => {
        bounceTransition.value = "bounceInDown";
        resolve();
      }, timeOut.value);
    });
  };

  return {
    showModal,
    bounceTransition,
    fadeTransition,
    timeOut,
    handleModal,
    handleTransition,
  };
};
